import React from 'react';

const TextButton = ({ text, onClick, style }) => {
  return (
    <div
      className="font-md-regular text-button"
      onClick={onClick}
      style={{ ...style }}
    >
      {text}
    </div>
  );
};

export default TextButton;
